import React from "react";
import { Nav, Sidenav, Dropdown } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { Link, withRouter } from "react-router-dom";
import { clientAccess, getModules } from "./utils/index";

class SideMenu extends React.Component {
  state = {
    openMenu: this.props.openMenu ? [this.props.openMenu] : [""],
    activeKey: this.props.activeKey ? this.props.activeKey : "1-1",
  };

  renderDropdowns() {
    const url = this.props.match;
    const dropdowns = [];

    
    dropdowns.push(
      <Dropdown eventKey="1" title="Client Profile" key="client-profile">
        {clientAccess() && (
        <Dropdown.Item
          eventKey="1-1"
          componentClass={Link}
          to="/masters/client-profile"
          onSelect={() => this.setState({ activeKey: "1-1" })}
        >
          Client Profile Setup
        </Dropdown.Item>
        )}

        <Dropdown.Item
          eventKey="1-2"
          componentClass={Link}
          to="/masters/client-access-setup"
          onSelect={() => this.setState({ activeKey: "1-2" })}
        >
          Client Access Setup
        </Dropdown.Item>
      </Dropdown>
    );


    if(getModules().includes(1) || getModules().includes(3)){
      dropdowns.push(
        <Dropdown eventKey="2" title="Unit Directory" key="unit-directory">
          <Dropdown.Item
            eventKey="2-1"
            componentClass={Link}
            to={`${url.path}/asset-detail`}
            onSelect={() => {
              this.state.activeKey = "2-1";
            }}
          >
            Asset Detail
          </Dropdown.Item>
          <Dropdown.Item
            eventKey="2-2"
            componentClass={Link}
            to={`${url.path}/unit-detail`}
            onSelect={() => this.setState({ activeKey: "2-2" })}
          >
            Unit Detail
          </Dropdown.Item>
        </Dropdown>
      );
    }

    if (getModules().includes(1)) {
      dropdowns.push(
        <Dropdown
          eventKey="3"
          title="Landlord Directory"
          // // // icon={<FontAwesomeIcon icon={faKey} />}
        >
          <Dropdown.Item
            componentClass={Link}
            to={`${url.path}/landlord-company-details`}
            onSelect={() => {
              this.state.activeKey = "3-1";
            }}
            eventKey="3-1"
          >
            Landlord Company Details
          </Dropdown.Item>

          <Dropdown.Item
            componentClass={Link}
            to={`${url.path}/landlord`}
            onSelect={() => {
              this.state.activeKey = "3-2";
            }}
            eventKey="3-2"
          >
            Landlord Address Details
          </Dropdown.Item>

          <Dropdown.Item
            componentClass={Link}
            to={`${url.path}/landlord-contact-details`}
            onSelect={() => {
              this.state.activeKey = "3-3";
            }}
            eventKey="3-3"
          >
            Landlord Contact Details
          </Dropdown.Item>
          <Dropdown.Item
            componentClass={Link}
            to={`${url.path}/landlord-bank-details`}
            onSelect={() => {
              this.state.activeKey = "3-4";
            }}
            eventKey="3-4"
          >
            Landlord Bank Details
          </Dropdown.Item>
        </Dropdown>
      );

      dropdowns.push(
        <Dropdown
                eventKey="4"
                title="Occupier Directory"
                // // // icon={<FontAwesomeIcon icon={faHouseUser} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/occupier-company-details`}
                  onSelect={() => {
                    this.state.activeKey = "4-1";
                  }}
                  eventKey="4-1"
                >
                  Occupier Company Details
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/occupier`}
                  onSelect={() => {
                    this.state.activeKey = "4-2";
                  }}
                  eventKey="4-2"
                >
                  Occupier Address Details
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/occupier-contact-details`}
                  onSelect={() => {
                    this.state.activeKey = "4-3";
                  }}
                  eventKey="4-3"
                >
                  Occupier Contact Details
                </Dropdown.Item>
              </Dropdown>
      );
      
      dropdowns.push(
        <Dropdown
                eventKey="5"
                title="Brand Directory"
                // // // icon={<FontAwesomeIcon icon={faCopyright} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/brand-details`}
                  onSelect={() => {
                    this.state.activeKey = "5-1";
                  }}
                  eventKey="5-1"
                >
                  Brand Details
                </Dropdown.Item>
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/product-master`}
                  onSelect={() => {
                    this.state.activeKey = "5-2";
                  }}
                  eventKey="5-2"
                >
                  Product Master
                </Dropdown.Item>
              </Dropdown>
      );

      
        if(clientAccess()){
          dropdowns.push(
          <Dropdown
            eventKey="6"
            title="Commercial Logic Master"
            // // // icon={<FontAwesomeIcon icon={faAtom} />}
          >
            <Dropdown.Item
              componentClass={Link}
              to={`${url.path}/rent-logic`}
              onSelect={() => {
                this.state.activeKey = "6-1";
              }}
              eventKey="6-1"
            >
              Rent Logic
            </Dropdown.Item>

            <Dropdown.Item
              componentClass={Link}
              to={`${url.path}/cam-logic`}
              onSelect={() => {
                this.state.activeKey = "6-2";
              }}
              eventKey="6-2"
            >
              CAM Logic
            </Dropdown.Item>

            <Dropdown.Item
              componentClass={Link}
              to={`${url.path}/property-tax`}
              onSelect={() => {
                this.state.activeKey = "6-3";
              }}
              eventKey="6-3"
            >
              Property tax Logic
            </Dropdown.Item>

            <Dropdown.Item
              componentClass={Link}
              to={`${url.path}/marketing-fund-logic`}
              onSelect={() => {
                this.state.activeKey = "6-4";
              }}
              eventKey="6-4"
            >
              Marketing Fund Logic
            </Dropdown.Item>
          </Dropdown>
          );
        }

        if(clientAccess()){
          dropdowns.push(
            <Dropdown
                  eventKey="7"
                  title="Charges Master"
                  // // // icon={<FontAwesomeIcon icon={faRupeeSign} />}
                >
                  <Dropdown.Item
                    componentClass={Link}
                    to={`${url.path}/utility-charges`}
                    onSelect={() => {
                      this.state.activeKey = "7-1";
                    }}
                    eventKey="7-1"
                  >
                    Utility Charges
                  </Dropdown.Item>
                  <Dropdown.Item
                    componentClass={Link}
                    to={`${url.path}/other-charges`}
                    onSelect={() => {
                      this.state.activeKey = "7-2";
                    }}
                    eventKey="7-2"
                  >
                    Other Charges
                  </Dropdown.Item>
                </Dropdown>
          );
        }

          dropdowns.push(
            <Dropdown
                eventKey="8"
                title="Clauses Master "
                // // // icon={<FontAwesomeIcon icon={faFileContract} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/commercial-clauses`}
                  onSelect={() => {
                    this.state.activeKey = "8-1";
                  }}
                  eventKey="8-1"
                >
                  Commercial Clauses
                </Dropdown.Item>
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/legal-clauses`}
                  onSelect={() => {
                    this.state.activeKey = "8-2";
                  }}
                  eventKey="8-2"
                >
                  Legal Clauses
                </Dropdown.Item>
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/compliance`}
                  onSelect={() => {
                    this.state.activeKey = "8-3";
                  }}
                  eventKey="8-3"
                >
                  Compliance Clauses
                </Dropdown.Item>
              </Dropdown>
          );

          dropdowns.push(
            <Dropdown
                eventKey="9"
                title="Taxation Master "
                // // // icon={<FontAwesomeIcon icon={faFileContract} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/taxation`}
                  onSelect={() => {
                    this.state.activeKey = "9-1";
                  }}
                  eventKey="9-1"
                >
                  Taxation
                </Dropdown.Item>
              </Dropdown>
          );

          dropdowns.push(
            <Dropdown
                eventKey="10"
                title="Broker Directory"
                // // // icon={<FontAwesomeIcon icon={faKey} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/broker-company-details`}
                  onSelect={() => {
                    this.state.activeKey = "10-1";
                  }}
                  eventKey="10-1"
                >
                  Broker Company Details
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/broker`}
                  onSelect={() => {
                    this.state.activeKey = "10-2";
                  }}
                  eventKey="10-2"
                >
                  Broker Address Details
                </Dropdown.Item>

                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/broker-contact-details`}
                  onSelect={() => {
                    this.state.activeKey = "10-3";
                  }}
                  eventKey="10-3"
                >
                  Broker Contact Details
                </Dropdown.Item>
              </Dropdown>
          );

          dropdowns.push(
            <Dropdown
                eventKey="11"
                title="Budget"
                // // // icon={<FontAwesomeIcon icon={faKey} />}
              >
                <Dropdown.Item
                  componentClass={Link}
                  to={`${url.path}/budget`}
                  onSelect={() => {
                    this.state.activeKey = "11-1";
                  }}
                  eventKey="11-1"
                >
                  Budget Master
                </Dropdown.Item>

              
              </Dropdown>
          );
    }

    if (getModules().includes(3)) {
      dropdowns.push(
        <Dropdown eventKey="12" title="Prospect" key="prospect">
          <Dropdown.Item
            eventKey="12-1"
            componentClass={Link}
            to={`${url.path}/prospect`}
            onSelect={() => this.setState({ activeKey: "12-1" })}
          >
            Prospect Master
          </Dropdown.Item>
        </Dropdown>
      );
    }

    return dropdowns;
  }

  render() {
    return (
      <div className="leftSidebar">
        <Sidenav
          activeKey={this.state.activeKey}
          openKeys={this.state.openMenu}
          onOpenChange={(openKeys) => {
            this.setState({ openMenu: [openKeys[openKeys.length - 1]] });
          }}
        >
          <Sidenav.Body>
            <Nav>{this.renderDropdowns()}</Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    );
  }
}

export default withRouter(SideMenu);
